import { render, staticRenderFns } from "./products.vue?vue&type=template&id=af65cf48&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&id=af65cf48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af65cf48",
  null
  
)

export default component.exports